import * as R from 'ramda';
import { createSelector } from 'reselect';

import EntityType from '../../utils/entityType';
import { AppState } from '../reducer';
import { SubmittingState } from './reducer';

export const submittingState$ = (state: AppState) => R.pathOr({}, ['submitting'], state);

export const submittingInvoiceMark$ = createSelector([submittingState$], (state: SubmittingState) =>
  R.pathOr(false, ['@@invoices'], state)
);

export const submittingOrder$ = createSelector([submittingState$], (state: SubmittingState) =>
  R.pathOr(false, [`@@${EntityType.ORDERS}`], state)
);

export const submittingAuth$ = createSelector([submittingState$], (state: SubmittingState) =>
  R.pathOr(false, [`@@${EntityType.SESSIONS}`], state)
);

export const submittingProfile$ = createSelector([submittingState$], (state: SubmittingState) =>
  R.pathOr(false, [`@@${EntityType.PROFILE}`], state)
);

export const submittingAuthOrOrder$ = createSelector(
  [submittingAuth$, submittingOrder$, submittingProfile$],
  (submittingAuth: boolean, submittingOrder: boolean, submittingProfile: boolean) =>
    submittingAuth || submittingOrder || submittingProfile
);
